import _range from "lodash/range";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import * as React from 'react';
import classnames from 'classnames';
import injectStyles from "../../jss";
import SliderStep from "./SliderStep.react";
import StepLabels from "./StepLabels.react";
import styles from "./SliderSteps.jss";

var SliderSteps = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(SliderSteps, _React$PureComponent);

  function SliderSteps() {
    _classCallCheck(this, SliderSteps);

    return _possibleConstructorReturn(this, _getPrototypeOf(SliderSteps).apply(this, arguments));
  }

  _createClass(SliderSteps, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          formater = _this$props.formater,
          max = _this$props.max,
          min = _this$props.min,
          shakySteps = _this$props.shakySteps,
          step = _this$props.step,
          value = _this$props.value,
          stepHeight = _this$props.stepHeight,
          exactSteps = _this$props.exactSteps,
          emphasizedValues = _this$props.emphasizedValues,
          unit = _this$props.unit,
          stepLabels = _this$props.stepLabels;
      var stepsCount = Math.ceil((max - min) / step);
      var maxStepsCount = 20;
      var optimalStepsCount = shakySteps ? 26 : 10; // For steps count numbers without any common divisor with numbers in range
      // 2..maxStepsCount will render no steps.

      var steps = exactSteps ? stepsCount + 2 : countSteps(stepsCount, maxStepsCount, optimalStepsCount);
      var stepIncrement = (max - min) / (steps - 2);

      var stepsArray = _range(steps + 1).map(function (i) {
        var stepValue = min + stepIncrement * (i - 1);
        return React.createElement(SliderStep, {
          key: i,
          index: i,
          emphasized: emphasizedValues.includes(stepValue),
          isAboveValue: stepValue > value,
          shakySteps: shakySteps,
          stepHeight: stepHeight,
          steps: steps
        });
      });

      return React.createElement("div", {
        className: classnames('sliderSteps', classes.wrapper)
      }, React.createElement("div", null, stepsArray), React.createElement("div", {
        className: classnames(classes.min, classes.range)
      }, formater(min, unit)), React.createElement("div", {
        className: classnames(classes.max, classes.range)
      }, formater(max, unit)), React.createElement(StepLabels, {
        min: min,
        max: max,
        stepLabels: stepLabels,
        labelClassName: classes.range
      }));
    }
  }]);

  return SliderSteps;
}(React.PureComponent);

_defineProperty(SliderSteps, "styleRoot", 'SliderSteps');

_defineProperty(SliderSteps, "defaultProps", {
  barHeight: 5,
  formater: function formater(value, unit) {
    return "".concat(unit, " ").concat(value);
  },
  stepHeight: 8
});

function countSteps(stepsCount, maxStepsCount, optimalStepsCount) {
  // eslint-disable-line
  for (var i = maxStepsCount; i >= 2; i--) {
    if (stepsCount % i === 0) {
      if (i < optimalStepsCount) return optimalStepsCount;
      if (i % 2 !== 0) return i + 1;
      return i;
    }
  }

  return optimalStepsCount;
}

export default injectStyles(styles)(SliderSteps);